import { UIElement } from '../ui-element';
import { Component } from '../../decorators/component.decorator';
import styles from './ui-definition-list.css';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIDefinitionList
 * @element ui-definition-list
 * @classdesc Represents a class for <code>ui-definition-list</code> element.
 * Serves as a list of label:value pairs. Replaces a need in text-only form fields.
 * Container for <code>ui-definition-list-item</code> elements (must be direct children).
 * @example
 * <ui-definition-list>
 *   <ui-definition-list-item label="Color">Green</ui-definition-list-item>
 *   <ui-definition-list-item label="Size">Medium</ui-definition-list-item>
 * </ui-definition-list>
 */
@Component({
    tag: 'ui-definition-list',
    styles,
})
export class UIDefinitionList extends UIElement {
    /**
     * Sets listitem role for direct ui-definition-list-item children.
     * @private
     */
    private applyListItemRolesToChildren(): void {
        for (const child of this.children) {
            if (child.localName === 'ui-definition-list-item') {
                child.setAttribute('role', 'listitem');
            }
        }
    }

    /**
     * @inheritDoc
     */
    render(): void {
        this.updateElement({
            attributes: {
                role: 'list',
            },
        });
    }

    /**
     * @inheritDoc
     */
    hydrate(): void {
        this.applyListItemRolesToChildren();
    }
}
